import React, { Component } from 'react';
import { Container, Header, Button, Checkbox, Form } from 'semantic-ui-react';
import { Editor, EditorState, RichUtils } from 'draft-js';
import 'draft-js/dist/Draft.css';
import RichEditor from '../Editor/RichEditor';
import { stateToHTML } from 'draft-js-export-html';
import { GetData, PostData } from './../../api/Service';
import FileUpload from './FileUpload';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import RichTextEditor from './../RichText/RichTextEditor';
class NewEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date1:'',
            title: '',
            venue: '',
            time: '',
            description: '',
            upInfo: [],
            tempInfo:[],
            type: '',
            subtype: '',
            key: '',
            submit: '',
            editorState: ''
        };
        
        this.onSubmit = this.onSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onEditorChange = this.onEditorChange.bind(this);
    }


    componentDidMount() {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);
        let key = user.key;
        let user_id = user._user_.id;

        let url = `api/upload/${key}/api_upload_key/events/${user_id}`;
        GetData(url)
            .then((data) => {
                //console.log(data);
                this.setState({
                    type: data.type,
                    subtype: data.subtype,
                    key: data.key,
                    submit: data.submit
                })
            }

            );
    }

    onEditorChange(value){
        this.setState({
            editorState: value
        })
    }

    handleChange(e) {
        var state = {};
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    onNewUpload = (value) => {


        let arr = this.state.upInfo.concat(value.files.fileUpload);
        console.log(arr);
        this.setState({
            upInfo: arr
        });



    }

    onSubmit(e) {
        e.preventDefault();

        let user = localStorage.getItem('user');
        user = JSON.parse(user);
        let key = user.key;
        let user_id = user._user_.id;

        //console.log(stateToHTML(this.state.editorState.getCurrentContent()));
        //short out the data
        const descarray = {
            description: this.state.description,
            time: this.state.time,
            venue: this.state.venue
        }
        const date1 = this.state.date1;
        const title = this.state.title;
        const upInfo = this.state.upInfo;
        const longd = this.state.editorState;

        const data = {
            ctgy: '1',
            head: title,
            desc: [descarray],
            upInfo: upInfo,
            msg: longd,
            cBy: user_id,
            date: date1,
            id: user_id
        }

        var url = `api/insert/${key}/new/${this.state.submit}`;
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this._postData(url, data)
                },
                {
                    label: 'No',
                    onClick: () => window.location.reload()
                }
            ]
        })
    }

    _postData(url, data) {
        PostData(url, data)
            .then((data) => {
                //console.log(data)
                if (data.affectedRows === 1) {
                    confirmAlert({
                        title: 'Successfully Submitted',
                        message: 'Your news has been successfully posted',
                        buttons: [
                            {
                                label: 'Okay',
                                onClick: () => this._initialize()
                            }
                        ]
                    })
                } else {
                    confirmAlert({
                        title: 'Something Went Wrong',
                        message: 'Please Contact your administrator',
                        buttons: [
                            {
                                label: 'Okay',
                                onClick: () => this._initialize()
                            }
                        ]
                    })
                }
            });
    }

    handleKeyCommand(command, editorState) {
        const newState = RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            this.onChange(newState);
            return 'handled';
        }
        return 'not-handled';
    }

    _initialize(){
        window.location.reload();
        this.setState({
            date1: '',
            title: '',
            venue: '',
            time: '',
            description: '',
            upInfo: [],
            tempInfo: [],
            editorState: ''
        })
    }


    render() {
        let uploadFiles = [];
        if (this.state.upInfo.length > 0) {
            let arr = this.state.upInfo;
            uploadFiles = arr.map((el, index) =>
                <li key={index}>{el.name}</li>
            )
        }
        return (
            <div>
                <h2>Add new Event</h2>
                <Form onSubmit={this.onSubmit}>
                    <Form.Field>
                        <label>Date</label>
                        <input 
                            type="date"
                            placeholder='Date'
                            name="date1"
                            value={this.state.date1}
                            onChange={this.handleChange}
                            required={true}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Title</label>
                        <input 
                            type="text"
                            name="title"
                            placeholder='Title'
                            value={this.state.title}
                            onChange={this.handleChange}
                            required={true} 
                            />
                    </Form.Field>

                    <Form.Field>
                        <label>Venue</label>
                        <input 
                            type="text"
                            name="venue"
                            placeholder='Venue'
                            value={this.state.venue}
                            onChange={this.handleChange}
                            required={true}
                        />
                    </Form.Field>

                    <Form.Field>
                        <label>Time</label>
                        <input  
                            type="text"
                            name="time"
                            placeholder='Time'
                            value={this.state.time}
                            onChange={this.handleChange}
                            required={true}
                        />
                    </Form.Field>

                    <Form.Field>
                        <label>Short Description</label>
                        <textarea 
                            name="description"
                            placeholder='Short Description'
                            value={this.state.description}
                            onChange={this.handleChange}
                            required={true}
                        ></textarea>
                    </Form.Field>

                    <Form.Field>
                        <label>Detailed Description</label>
                        <div>


                            <RichTextEditor
                                onChange={this.onEditorChange}
                                placeholder="Type Something here"
                            />


                            {/* <RichEditor
                                editorState={this.state.editorState}
                                onChange={(editorState) => this.setState({ editorState })}
                                placeholder="You can write HTML here....."
                            /> */}
                        </div>
                    </Form.Field>

            
                    <ol className="file-list-show">
                        {uploadFiles}
                    </ol>
                    <br/>
                 

                    <Button type='submit'>Submit</Button>
                </Form>

                <br/>
                <FileUpload onChange={this.onNewUpload.bind(this)} type={this.state.type} subtype={this.state.subtype} key_id={this.state.key} submit={this.state.submit} />
            </div>
        )
    }
}

export default NewEvent;


// WEBPACK FOOTER //
// ./src/HomeComponents/Events/NewEvent.js